<template>
	<el-row class="container">
		<el-col :span="24" class="header">
			<el-col :span="10" class="logo" :class="collapsed ? 'logo-collapse-width' : 'logo-width'">
				{{ collapsed ? '' : sysName }}
			</el-col>
			<el-col :span="10">
				<div class="tools" @click.prevent="collapse">
					<i class="fa fa-align-justify"></i>
				</div>
			</el-col>
			<el-col :span="4" class="userinfo">
				<el-dropdown trigger="hover">
					<span class="el-dropdown-link userinfo-inner">{{ sysUserName }}</span>
					<el-dropdown-menu slot="dropdown">
						<!-- <el-dropdown-item divided  @click.native="changePassWord">修改密码</el-dropdown-item> -->
						<el-dropdown-item divided @click.native="logout">退出登录</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				<el-dialog title="修改密码" :visible.sync="dialogEdit" :append-to-body="true" width="30%">
					<el-form :model="passWordForm" ref="passWordForm" :rules="rule">
						<el-form-item>
							<el-col :span="24">
								<el-form-item label="原始密码:" prop="originalpassword" label-width="110px">
									<el-input v-model="passWordForm.originalpassword"></el-input>
								</el-form-item>
							</el-col>
						</el-form-item>
						<el-form-item>
							<el-col :span="24">
								<el-form-item label="新密码:" prop="password" label-width="110px">
									<el-input  maxlength="10" minlength="3" v-model="passWordForm.password"></el-input>
								</el-form-item>
							</el-col>
						</el-form-item>
						<el-form-item>
							<el-col :span="24">
								<el-form-item label="确认新密码:" prop="checkPassword" label-width="110px">
									<el-input   maxlength="10" minlength="3" v-model="passWordForm.checkPassword"></el-input>
								</el-form-item>
							</el-col>
						</el-form-item>
						<el-form-item style="text-align: center">
							<el-col :span="24">
								<el-button @click="resetForm('passWordForm')">取消</el-button>
								<el-button type="primary" @click="submitForm('passWordForm')">提交</el-button>
							</el-col>
						</el-form-item>
					</el-form>
				</el-dialog>

			</el-col>
		</el-col>
		<el-col :span="24" class="main">
			<aside>
				<!--导航菜单-->
				<el-menu :default-active="$route.path" class="el-menu-vertical-demo" @open="handleopen" @close="handleclose"
					@select="handleselect" unique-opened router :collapse="collapsed">
					<template v-for="(item, index) in routerList">
						<template v-if="!item.hidden">
							<el-submenu :index="index + ''" :key="index" v-if="!item.leaf">
								<template slot="title"><i :class="item.iconCls"></i><span slot="title">{{ item.name }}</span></template>
								<el-menu-item v-for="child in item.children" :index="child.path" :key="child.path">
									<span v-if="!child.hidden">{{ child.name }}</span>
								</el-menu-item>
							</el-submenu>
							<el-menu-item v-if="item.leaf && item.children.length > 0" :index="item.children[0].path"
								:key="index"><i :class="item.iconCls"></i><span slot="title">{{ item.children[0].name }}</span></el-menu-item>
						</template>
					</template>
				</el-menu>
			</aside>
			<section class="content-container">
				<div class="grid-content bg-purple-light">
					<el-col :span="24" class="breadcrumb-container">
						<strong class="title">{{ $route.name }}</strong>
						<el-breadcrumb separator="/" class="breadcrumb-inner">
							<el-breadcrumb-item v-for="item in $route.matched" :key="item.path">
								{{ item.name }}
							</el-breadcrumb-item>
						</el-breadcrumb>
					</el-col>
					<el-col :span="24" class="content-wrapper">
						<transition name="fade" mode="out-in">
							<router-view></router-view>
						</transition>
					</el-col>
				</div>
			</section>
		</el-col>
		<el-col :span="24" class="footer">
			吉林市昌邑区吉麟珠宝店 Copyright © 2026 <a href="https://beian.miit.gov.cn" target="_blank">吉ICP备2026000884号</a>
		</el-col>
	</el-row>
</template>

<script>
import { requestLogout,changePassword } from '../api/api';
export default {
	data() {
		var validatePass = (rule, value, callback) => {
		var pass = /^(?=.*?[a-z)(?=.*>[A-Z])(?=.*?[0-9])[a-zA_Z0-9]{8,10}$/gi;
		if (!pass.test(value)) {
				callback(new Error("请输入8-10位英文和数字组成的密码"));
			} else {
				if (this.form.checkPassword !== "") {
				this.$refs.form.validateField("checkPassword");
				}
				callback();
			}
		};
		var validatePass2 = (rule, value, callback) => {
			if (value === "") {
				callback(new Error("请再次输入新密码"));
			} else if (value !== this.passWordForm.password) {
				callback(new Error("两次输入密码不一致!"));
			} else {
				callback();
			}
		};
		return {
			sysName: '吉麟珠宝',
			collapsed: false,
			sysUserName: '',
			sysUserAvatar: '',
			dialogEdit:false,
			form: {
				name: '',
				region: '',
				date1: '',
				date2: '',
				delivery: false,
				type: [],
				resource: '',
				desc: ''
			},
			passWordForm: {
        		originalpassword: "", //原始密码
        		password: "", //新密码
        		checkPassword: "", //确认密码
      		},
			  rule: {
				originalpassword: [
				{ required: true, message: "请输入原始密码", trigger: "blur" },
				// { validator: validateoriginalPass, trigger: "blur" },
				],
				password: [
				{ required: true, message: "请输入新密码", trigger: "blur" },
				{ validator: validatePass, trigger: "blur" },
				],
				checkPassword: [
				{ required: true, message: "请再次输入新密码", trigger: "blur" },
				{ validator: validatePass2, trigger: "blur" },
				],
			}
		}
	},
	computed: {
		routerList() {
			// console.log('computed---')
			let list = this.$router.options.routes;
			let user = localStorage.getItem('user');
			let role = '';
			if (user) {
				user = JSON.parse(user);
				role = user.role;
			}
			const routes = permissionRouter()
			function permissionRouter(router = list) {
				return router.filter(item => {
					if (item.children) {
						item.children = permissionRouter(item.children)
					}
					return item.meta.permission.includes(role)
				})
			}
			return routes
		}
	},
	methods: {
		changePassWord: function(){
			console.log("修改密码");
					this.dialogEdit = true;
					this.title = "修改密码";
					this.form = {
						originalpassword: "", //原始密码
						password: "",//新密码
						checkPassword: "",//确认密码
					};
		},
		onSubmit() {
			console.log('submit!');
		},
		handleopen() {
			//console.log('handleopen');
		},
		handleclose() {
			//console.log('handleclose');
		},
		handleselect: function (a, b) {
		},
		//退出登录
		logout: function () {
			var _this = this;
			this.$confirm('确认退出吗?', '提示', {
				//type: 'warning'
			}).then(() => {

				requestLogout().then(res => {
					console.log('退登', res);
					localStorage.clear()
					_this.$router.push('/login');
				})
			}).catch(() => {

			});


		},
		submitForm: function(formName) {
			this.$refs[formName].validate(async (valid) => {
				if (valid) {
					let para = { newPassword: this.passWordForm.password,oldPassword: this.passWordForm.originalpassword};
					changePassword(para).then((res) => {
						console.log('修改密码', res)
						if (res.data.code == 10000) {
							this.$message.success("修改成功！");
							this.dialogEdit = false;
						}else {
							this.$message.error(res.msg);
						}
					}).catch(() => {
						this.$message.error(res.msg);
					});	

				}
			});
    	},
		resetForm(formName) {
			this.dialogEdit = false;
			this.$refs[formName].resetFields();
		},
		//折叠导航栏
		collapse: function () {
			this.collapsed = !this.collapsed;
		},
		showMenu(i, status) {
			this.$refs.menuCollapsed.getElementsByClassName('submenu-hook-' + i)[0].style.display = status ? 'block' : 'none';
		}
	},
	mounted() {
		var user = localStorage.getItem('user');
		if (user) {
			user = JSON.parse(user);
			this.sysUserName = user.merchantName || '管理员';
		}

	}
}

</script>

<style scoped lang="scss">
@import '~scss_vars';

.container {
	position: absolute;
	top: 0px;
	bottom: 0px;
	width: 100%;

	.header {
		height: 60px;
		line-height: 60px;
		background: $color-primary;
		color: #fff;

		.userinfo {
			text-align: right;
			padding-right: 35px;
			float: right;

			.userinfo-inner {
				cursor: pointer;
				color: #fff;

				img {
					width: 40px;
					height: 40px;
					border-radius: 20px;
					margin: 10px 0px 10px 10px;
					float: right;
				}
			}
		}

		.logo {
			//width:230px;
			height: 60px;
			font-size: 22px;
			padding-left: 20px;
			padding-right: 20px;
			border-color: rgba(238, 241, 146, 0.3);
			border-right-width: 1px;
			border-right-style: solid;

			img {
				width: 40px;
				float: left;
				margin: 10px 10px 10px 18px;
			}

			.txt {
				color: #fff;
			}
		}

		.logo-width {
			width: 230px;
		}

		.logo-collapse-width {
			width: 64px
		}

		.tools {
			padding: 0px 23px;
			width: 14px;
			height: 60px;
			line-height: 60px;
			cursor: pointer;
		}
	}

	.main {
		display: flex;
		// background: #324057;
		position: absolute;
		top: 60px;
		bottom: 20px;
		overflow: hidden;

		aside {
			// flex: 0 0 230px;
			// width: 230px;

			// position: absolute;
			// top: 0px;
			// bottom: 0px;
			.el-menu {
				height: 100%;
			}

			.el-menu-vertical-demo:not(.el-menu--collapse) {
				width: 230px;
				flex: 0 0 230px;
			}

			// .collapsed {
			// 	width: 60px;

			// 	.item {
			// 		position: relative;
			// 	}

			// 	.submenu {
			// 		position: absolute;
			// 		top: 0px;
			// 		left: 60px;
			// 		z-index: 99999;
			// 		height: auto;
			// 		display: none;
			// 	}

			// }
		}

		.content-container {
			// background: #f1f2f7;
			flex: 1;
			// position: absolute;
			// right: 0px;
			// top: 0px;
			// bottom: 0px;
			// left: 230px;
			overflow-y: scroll;
			padding: 20px;

			.breadcrumb-container {

				//margin-bottom: 15px;
				.title {
					width: 200px;
					float: left;
					color: #475669;
				}

				.breadcrumb-inner {
					float: right;
				}
			}

			.content-wrapper {
				background-color: #fff;
				box-sizing: border-box;
			}
		}
	}

	.footer {
		position: absolute;
		bottom: 0;
		left: 0;
		text-align: center;
		font-size: 14px;
		color: #939393;
		line-height: 20px;

		a {
			color: #939393;
			text-decoration: none;
		}
	}
}
</style>


// WEBPACK FOOTER //
// Home.vue?4d5b1534